import './studio.css';
import CssBaseline from '@material-ui/core/CssBaseline';
import { useRef, useEffect, useState } from "react";
import StudioContent from './studioContent';
import AephoriaLogo from "../images/Aephoria-logo-blue.png"
import * as aserver from '../../APIClient';
const axios = require('axios').default;

const Copyright = () => {
    return (<div style={{ width: '100%', textAlign: 'center', marginTop: '2em', marginBottom: '2em' }}>Aephoria Copyright 2011-{new Date().getFullYear()}</div>)
}

const CustomReports = (props) => {
    const pathparts = window.location.pathname.split('/');
    const assessmentUUID = pathparts[pathparts.length - 1];
    const reportCode = props.legacy ? 'e' : pathparts[pathparts.length - 2];
    const urlParams = new URLSearchParams(window.location.search);
    const requestedLanguage = urlParams.get('language');
    const requestedVersion = urlParams.get('version');
    const notEnglish = requestedLanguage && (requestedLanguage !== 'english')
    const reportName = {
        e: 'Enneagram',
        m: 'Maturity',
        c: 'Combined',
        cp: 'Combined+'
    }[reportCode] + ' Report';

    function getIsNarrow() {
        if (onlyText)
            return (true)
        else
            return (window.innerWidth < 800);
    }

    const [isNarrow, setIsNarrow] = useState(getIsNarrow());
    const [onlyText, setOnlyText] = useState(false);

    useEffect(() => {
        function handleResize() {
            setIsNarrow(getIsNarrow());
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [onlyText]);


    const [selectedTab, setSelectedTab] = useState(null);
    const [results, setResults] = useState(null);
    const [tabs, setTabs] = useState([]);
    const [refresher, setRefresher] = useState(null);


    function tabsReady(_tabs) {
        setTabs(_tabs);
        let initialTab = _tabs.find(t => (t.id === localStorage.getItem('selectedTabId'))) || _tabs[1];
        setSelectedTab(initialTab);
    }

    function showContent() {
        let s = [];
        for (let t of tabs) {
            s.push(<div id={t.id}><h2>{t.name}</h2>{t.content}</div>)
        }
        return (s.map((c, index) => <div key={index}>{c}</div>));
    }

    useEffect(() => {
        async function getResults() {
            try {
                const response = await axios.get(
                    `${aserver.getServerRoot()}/${`api/v2/guestresults/${assessmentUUID}`}?reportCode=${reportCode}&language=${requestedLanguage}&version=${requestedVersion}&t=${+ new Date()}`
                );
                if ((response.data) && (response.data.error)) {
                    window.alert(response.data.error);
                    return;
                }
                //console.log('GETRESULTS:', response.data);
                setResults(response.data);
                if (response.data.onlyText) {
                    setIsNarrow(true);
                    setOnlyText(true);
                }
            } catch (err) {
                console.log(err)
            }
        };
        getResults();
    }, [assessmentUUID]);


    let htmlContent = !results ? <></> : <StudioContent
        reportContent={results.reportContent}
        assessment={results.guest}
        results={results}
        onTabsReady={tabsReady}
        refresher={refresher}
        isNarrow={isNarrow}
        reportCode={reportCode}
        reportName={reportName}
        notEnglish={notEnglish}
        reportLanguage={requestedLanguage}
        assessmentName={results.guest.assessmentTypeName}
    />

    return (<>
        <CssBaseline />
        <div className='studioContainer'>
            {!results ? <>Loading...</> : <>
                <div>
                    {htmlContent}
                    <div >
                        {selectedTab &&
                            <div id='studioWideContent' className='studioWideContent' role="main">
                                <div>{showContent()}</div>
                                <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
                                <Copyright />
                                <div style={{ width: '100%', textAlign: 'center' }}>
                                    <img className="navLogo" style={{ width: '20em' }} src={AephoriaLogo} alt="aephoria-logo" />
                                </div>
                            </div>}
                    </div>
                </div>
            </>}
        </div>
    </>)

};

export default CustomReports;
